/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHsoCustomerRedirectViewProps } from './hso-customer-redirect';

export default (props: IHsoCustomerRedirectViewProps) => {
    return <span></span>;
};
